import { ComponentType, CSSProperties } from 'react';

import { Award } from './award';
import { Bed } from './bed';
import { BedEstate } from './bed-estate';
import { Bell } from './bell';
import { BellSimple } from './bell-simple';
import { Bricks } from './bricks';
import { Building } from './building';
import { CenterLocation } from './center-location';
import { Chair } from './chair';
import { Check } from './check';
import { Check2 } from './check-two';
import { Checklist } from './checklist';
import { Checkmark } from './checkmark';
import { CheckmarkCircle } from './checkmark-circle';
import { CheckmarkRounded } from './checkmark-rounded';
import { CheckmarkRoundedGreen } from './checkmark-rounded-green';
import { CheckmarkRoundedWhite } from './checkmark-rounded-white';
import { Chevron } from './chevron';
import { ChevronForward } from './chevron-forward';
import { Clear } from './clear';
import { Close } from './close';
import { DealMade } from './deal-made';
import { Comments } from './comments';
import { Envelope } from './envelope';
import { ErrorSign } from './error-sign';
import { EstateZero } from './estate-zero';
import { FaCheckCircle } from './fa-check-circle';
import { FaMoneyBillWave } from './fa-money-bill-wave';
import { FaThumbUp } from './fa-thumb-up';
import { FacebookSquare } from './facebook-square';
import { Feedback } from './feedback';
import { Fence } from './fence';
import { FenceGray } from './fence-gray';
import { Flat } from './flat';
import { FloorArea } from './floor-area';
import { Fullscreen } from './fullscreen';
import { Hamburger } from './hamburger';
import { HandPointUp } from './hand-point-up';
import { Handshake } from './handshake';
import { HeartInHand } from './heart-in-hand';
import { HourGlassHalf } from './hourglass-half';
import { House } from './house';
import { HouseHero } from './house-hero';
import { HouseGray } from './house-gray';
import { HousePurpose } from './house-purpose';
import { ImagePlaceholder } from './image-placeholder';
import { Info } from './info';
import { InstagramSquare } from './instagram-square';
import { Land } from './land';
import { LocationTwo } from './location-two';
import { Lock } from './lock';
import { Logo } from './logo';
import { Mail } from './mail';
import { Map } from './map';
import { Marketing } from './marketing';
import { Marker } from './marker';
import { MarkerBuilding } from './marker-building';
import { MarkerFlat } from './marker-flat';
import { Menu } from './menu';
import { Minus } from './minus';
import { MinusCircle } from './minus-circle';
import { MoneyBillWave } from './money-bill-wave';
import { NewsBlog } from './news-blog';
import { OtherEstate } from './other-estate';
import { Phone } from './phone';
import { PhoneB } from './phone-b';
import { PhoneInTalk } from './phone-in-talk';
import { Plus } from './plus';
import { PropertyPrice } from './property-price';
import { PropertyValuation } from './property-valuation';
import { Reas } from './reas';
import { Reminder } from './reminder';
import { ReasStory } from './reas-story';
import { RoundCheck } from './round-check';
import { SalePreparation } from './sale-preparation';
import { SaleTiming } from './sale-timing';
import { Settings } from './settings';
import { Share } from './share';
import { Shield } from './shield';
import { SquareArea } from './square-area';
import { Star } from './star';
import { StarHalf } from './star-half';
import { TimerCheckmark } from './timer-checkmark';
import { UserTie } from './user-tie';
import { MagnifyingGlass } from './magnifying-glass';
import { ArrowPointingToBottomRight } from './arrow-pointing-to-bottom-right';
import { ArrowPointingToTopRight } from './arrow-pointing-to-top-right';
import { ArrowPointingToBottom } from './arrow-pointing-to-bottom';
import { ArrowPointingToTop } from './arrow-pointing-to-top';
import { InfoOutlined } from './info-outlined';
import { Upload } from './upload';
import { Camera } from './camera';
import { Pen } from './pen';
import { NewWindow } from './new-window';
import { Alert } from './alert';
import { WarningSquare } from './warning-square';
import { Diameter } from './diameter';
import { DiameterThick } from './diameter-thick';
import { Cross } from './cross';
import { EyeHidden } from './eye-hidden';
import { CheckmarkRoundedOutline } from './checkmark-rounded-outline';
import { BankNotes } from './bank-notes';
import { GraphUptrendCircle } from './graph-uptrend-circle';
import { MinusCircleDecorated } from './minus-circle-decorated';
import { CheckmarkRoundedLess } from './checkmark-rounded-less';
import { MapPointer } from './map-pointer';
import { Clock } from './clock';
import { PlusCircle } from './plus-circle';
import { PlusCircleBlue } from './plus-circle-blue';
import { ScreenPriceGraph } from './screen-price-graph';
import { PersonBubbleHouse } from './person-bubble-house';
import { HandsWithMoney } from './hands-with-money';
import { ComputerConsultation } from './computer-consultation';
import { RecreationalBuilding } from './recreational-building';
import { HouseWithSuccess } from './house-with-success';
import { HouseWithWarn } from './house-with-warn';
import { HouseWithError } from './house-with-error';
import { ArrowRight } from './arrow-right';

export type BaseIconProps = {
  fill?: string;
};
export type IconType =
  | 'award'
  | 'bed'
  | 'bed-estate'
  | 'bell'
  | 'bell-simple'
  | 'bricks'
  | 'building'
  | 'center-location'
  | 'chair'
  | 'check'
  | 'check-2'
  | 'checklist'
  | 'checkmark'
  | 'checkmark-blue'
  | 'checkmark-circle'
  | 'checkmark-rounded'
  | 'checkmark-rounded-green'
  | 'checkmark-rounded-white'
  | 'checkmark-rounded-outline'
  | 'chevron-down'
  | 'chevron-forward-b'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'clear'
  | 'close'
  | 'comments'
  | 'deal-made'
  | 'envelope'
  | 'error-sign'
  | 'estate-zero'
  | 'eye-hidden'
  | 'fa-check-circle'
  | 'fa-money-bill-wave'
  | 'fa-thumb-up'
  | 'facebook-square'
  | 'feedback'
  | 'fence'
  | 'fence-gray'
  | 'flat'
  | 'floor-area'
  | 'fullscreen'
  | 'hand-point-up'
  | 'hamburger'
  | 'handshake'
  | 'heart-in-hand'
  | 'hourglass-half'
  | 'house'
  | 'house-hero'
  | 'house-gray'
  | 'house-purpose'
  | 'house-with-success'
  | 'house-with-warn'
  | 'house-with-error'
  | 'image-placeholder'
  | 'info'
  | 'instagram-square'
  | 'land'
  | 'location-b'
  | 'lock'
  | 'logo'
  | 'mail'
  | 'map'
  | 'marketing'
  | 'marker'
  | 'marker-building'
  | 'marker-flat'
  | 'menu'
  | 'minus'
  | 'minus-circle'
  | 'minus-gray'
  | 'money-bill-wave'
  | 'new-window'
  | 'news-blog'
  | 'other-estate'
  | 'phone'
  | 'phone-b'
  | 'phone-in-talk'
  | 'plus'
  | 'property-price'
  | 'property-valuation'
  | 'reas'
  | 'reas-story'
  | 'reminder'
  | 'round-check'
  | 'sale-preparation'
  | 'sale-timing'
  | 'settings'
  | 'share'
  | 'shield'
  | 'square-area'
  | 'star'
  | 'star-half'
  | 'timer-checkmark'
  | 'user-tie'
  | 'magnifying-glass'
  | 'arrow-pointing-to-top-right'
  | 'arrow-pointing-to-bottom-right'
  | 'arrow-pointing-to-bottom'
  | 'arrow-pointing-to-top'
  | 'camera'
  | 'info-outlined'
  | 'upload'
  | 'pen'
  | 'alert'
  | 'warning-square'
  | 'diameter'
  | 'diameter-thick'
  | 'bank-notes'
  | 'graph-uptrend-circle'
  | 'cross'
  | 'minus-circle-decorated'
  | 'checkmark-rounded-less'
  | 'map-pointer'
  | 'clock'
  | 'plus-circle'
  | 'plus-circle-blue'
  | 'screen-price-graph'
  | 'person-bubble-house'
  | 'hands-with-money'
  | 'recreational-building'
  | 'computer-consultation'
  | 'arrow-right';

type IconTypesMap = {
  [key in IconType]: {
    component: ComponentType<BaseIconProps>;
    style?: CSSProperties;
  };
};

export const iconTypes: IconTypesMap = {
  award: { component: Award },
  bed: { component: Bed },
  'bed-estate': { component: BedEstate },
  bell: { component: Bell },
  'bell-simple': { component: BellSimple },
  bricks: { component: Bricks },
  building: { component: Building },
  'center-location': { component: CenterLocation },
  chair: { component: Chair },
  check: { component: Check },
  'check-2': { component: Check2 },
  checklist: { component: Checklist },
  checkmark: { component: Checkmark },
  'checkmark-circle': { component: CheckmarkCircle },
  'checkmark-rounded': { component: CheckmarkRounded },
  'checkmark-rounded-outline': { component: CheckmarkRoundedOutline },
  'checkmark-blue': { component: CheckmarkCircle, style: { color: '#1c85e8' } },
  'checkmark-rounded-green': {
    component: CheckmarkRoundedGreen,
    style: { color: '#3bbf00' },
  },
  'checkmark-rounded-white': {
    component: CheckmarkRoundedWhite,
  },
  'chevron-left': {
    component: Chevron,
    style: { transform: 'rotate(180deg)' },
  },
  'chevron-right': { component: Chevron },
  'chevron-down': {
    component: Chevron,
    style: { transform: 'rotate(90deg)' },
  },
  'chevron-up': {
    component: Chevron,
    style: { transform: 'rotate(-90deg)' },
  },
  'chevron-forward-b': { component: ChevronForward },
  clear: { component: Clear },
  close: { component: Close },
  comments: { component: Comments },
  'deal-made': { component: DealMade },
  envelope: { component: Envelope },
  'error-sign': { component: ErrorSign },
  'estate-zero': { component: EstateZero },
  'fa-check-circle': { component: FaCheckCircle },
  'fa-money-bill-wave': { component: FaMoneyBillWave },
  'fa-thumb-up': { component: FaThumbUp },
  'facebook-square': { component: FacebookSquare },
  feedback: { component: Feedback },
  fence: { component: Fence },
  'fence-gray': { component: FenceGray },
  flat: { component: Flat },
  'floor-area': { component: FloorArea },
  fullscreen: { component: Fullscreen },
  hamburger: { component: Hamburger },
  'hand-point-up': { component: HandPointUp },
  handshake: { component: Handshake },
  'heart-in-hand': { component: HeartInHand },
  'hourglass-half': { component: HourGlassHalf },
  house: { component: House },
  'house-with-success': { component: HouseWithSuccess },
  'house-with-warn': { component: HouseWithWarn },
  'house-with-error': { component: HouseWithError },
  'house-hero': { component: HouseHero },
  'house-gray': { component: HouseGray },
  'house-purpose': { component: HousePurpose },
  info: { component: Info },
  'image-placeholder': { component: ImagePlaceholder },
  'instagram-square': { component: InstagramSquare },
  land: { component: Land },
  'location-b': { component: LocationTwo },
  lock: { component: Lock },
  logo: { component: Logo },
  mail: { component: Mail },
  map: { component: Map },
  marketing: { component: Marketing },
  marker: { component: Marker },
  'marker-building': { component: MarkerBuilding },
  'marker-flat': { component: MarkerFlat },
  menu: { component: Menu },
  minus: { component: Minus },
  'minus-gray': {
    component: MinusCircle,
    style: {
      color: '#555b77',
    },
  },
  'minus-circle': {
    component: MinusCircle,
  },
  'money-bill-wave': { component: MoneyBillWave },
  'new-window': { component: NewWindow },
  'news-blog': { component: NewsBlog },
  'other-estate': { component: OtherEstate },
  phone: { component: Phone },
  'phone-b': { component: PhoneB },
  'phone-in-talk': { component: PhoneInTalk },
  plus: { component: Plus },
  'property-price': { component: PropertyPrice },
  'property-valuation': { component: PropertyValuation },
  reas: { component: Reas },
  'reas-story': { component: ReasStory },
  reminder: { component: Reminder },
  'round-check': { component: RoundCheck },
  'sale-preparation': { component: SalePreparation },
  'sale-timing': { component: SaleTiming },
  settings: { component: Settings },
  share: { component: Share },
  'square-area': { component: SquareArea },
  star: { component: Star },
  'star-half': { component: StarHalf },
  'user-tie': { component: UserTie },
  shield: { component: Shield },
  'timer-checkmark': { component: TimerCheckmark },
  'magnifying-glass': { component: MagnifyingGlass },
  'arrow-pointing-to-top-right': { component: ArrowPointingToTopRight },
  'arrow-pointing-to-bottom-right': { component: ArrowPointingToBottomRight },
  'arrow-pointing-to-bottom': { component: ArrowPointingToBottom },
  'arrow-pointing-to-top': { component: ArrowPointingToTop },
  camera: { component: Camera },
  'info-outlined': { component: InfoOutlined },
  upload: { component: Upload },
  pen: { component: Pen },
  alert: { component: Alert },
  'warning-square': { component: WarningSquare },
  diameter: { component: Diameter },
  'diameter-thick': { component: DiameterThick },
  cross: { component: Cross },
  'bank-notes': { component: BankNotes },
  'graph-uptrend-circle': { component: GraphUptrendCircle },
  'eye-hidden': { component: EyeHidden },
  'minus-circle-decorated': { component: MinusCircleDecorated },
  'checkmark-rounded-less': {
    component: CheckmarkRoundedLess,
    style: { color: '#3bbf00' },
  },
  'map-pointer': {
    component: MapPointer,
    style: {
      color: '#c2ccd8',
    },
  },
  clock: {
    component: Clock,
  },
  'plus-circle': {
    component: PlusCircle,
  },
  'plus-circle-blue': {
    component: PlusCircleBlue,
  },
  'screen-price-graph': {
    component: ScreenPriceGraph,
  },
  'person-bubble-house': {
    component: PersonBubbleHouse,
  },
  'hands-with-money': {
    component: HandsWithMoney,
  },
  'computer-consultation': {
    component: ComputerConsultation,
  },
  'recreational-building': { component: RecreationalBuilding },
  'arrow-right': { component: ArrowRight },
};
